import { Link, useLocation } from 'react-router';

import { useNavigationItems } from '~widgets/navigation/lib';

import { ROUTES } from '~shared/config/routes';

import cn from 'classnames';

import { SkyroLogo } from './skyro-logo';

import { Container } from '../layout';

type NavLinkProps = {
  to: string;
  name: string;
  isActive: boolean;
};

const NavLink = ({ to, name, isActive }: NavLinkProps) => {
  return (
    <Link
      to={to}
      className={cn('px-5 text-[17px] no-underline', {
        'font-medium text-[#191c1e]': !isActive,
        'font-semibold text-skyro-blue': isActive,
      })}
    >
      {name}
    </Link>
  );
};

export const Header = () => {
  const navigationItems = useNavigationItems();
  const { pathname } = useLocation();

  return (
    <header
      className={`
        flex h-20 items-center border-x-0 border-t-0 border-b border-solid
        border-[#eaecee] bg-white
      `}
    >
      <Container>
        <nav className="flex items-center justify-between gap-2">
          <Link to={ROUTES.root}>
            <SkyroLogo />
          </Link>
          <ul className="flex list-none items-center">
            {navigationItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  name={item.label}
                  isActive={pathname.startsWith(item.to)}
                />
              </li>
            ))}
          </ul>
        </nav>
      </Container>
    </header>
  );
};
